import Vue from 'vue';
import URLS from '../config/urls';

export default {
  login(credentials) {
    const headers = {
      'cache-control': 'no-cache',
      'content-type': 'application/json;charset=UTF-8',
    };
    const authURL = URLS.login;
    return Vue.axios.post(authURL, credentials, { headers });
  },
  logout() {
    localStorage.removeItem('tokenDetails');
    localStorage.removeItem('dealsFetchTime');
    localStorage.removeItem('deals');
  },
  saveToken(token) {
    const tokenDetails = {
      expirationTime: +new Date() + 86400000,
      token: `Bearer ${token}`,
    };
    localStorage.setItem('tokenDetails', JSON.stringify(tokenDetails));
  },
  getToken() {
    if (localStorage.getItem('tokenDetails')) {
      return JSON.parse(localStorage.getItem('tokenDetails')).token;
    }
    return false;
  },
  expirationCheck() {
    const currentTime = +new Date();

    if (localStorage.getItem('tokenDetails') && JSON.parse(localStorage.getItem('tokenDetails')).expirationTime) {
      const tokenExp = parseInt(JSON.parse(localStorage.getItem('tokenDetails')).expirationTime, 10);
      return currentTime - tokenExp > 60;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js